export default __webpack_public_path__ + "static/media/chargedstormchains.5792be8d.png";